module.exports = __webpack_public_path__ + "static/media/faqs@2x.c6cf8390.webm";